/*
 * PERSIAN PERRY — kampagneside (sections/pp-*.liquid)
 *
 * Én fil, vanilla, ingen afhængigheder. Sektionerne virker uden JS (rigtige formularer mod
 * /cart/add). JS lægger ovenpå:
 *
 *  1. Smagsvælger i hero: skifter data-active på sektionen. ?smag=<nøgle> vinder over startsmagen.
 *  2. Antal og kurv: stepper 1–max, knaptekst "{label} · {pris × antal}", tilføjelse via
 *     /cart/add.js med temaets bundlede sektioner. Derefter cart:change, som åbner temaets drawer.
 *  3. TikTok-facade: iframe indlæses først ved klik.
 *  4. Klaviyo: nyhedsbrev (subscriptions) og "Giv mig besked" (back-in-stock). Kun public key.
 *  5. Tracking: GA4-hændelser i dataLayer. Om de sendes videre, afgør GTM og samtykket, som
 *     for resten af shoppen (se snippets/content-page-view.liquid).
 *
 * Scriptet indlæses af alle fire sektioner, så det bindes kun én gang (window.__ppLanding).
 */
(function () {
  'use strict';
  if (window.__ppLanding) return;
  window.__ppLanding = true;

  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var desktop = window.matchMedia('(min-width: 901px)');

  /* ---------- Penge ----------
     Sektionen udskriver {{ 1234567 | money_with_currency }} i data-money-sample, fx
     "12.345,67 DKK" eller "€12.345,67 EUR". Ud fra den læses markedets tusind- og decimaltegn og det, der står før og
     efter beløbet. Så følger knapteksten samme format som resten af shoppen, på alle markeder. */
  function moneyFormatter(sample) {
    var m = /^(.*?)12(\D?)345(\D)67(.*)$/.exec(sample || '');
    if (!m) {
      return function (cents) { return (cents / 100).toFixed(2).replace('.', ',') + ' DKK'; };
    }
    var pre = m[1], thou = m[2], dec = m[3], post = m[4];
    return function (cents) {
      var whole = Math.floor(cents / 100);
      var frac = cents % 100;
      var w = String(whole).replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return pre + w + dec + String(frac).padStart(2, '0') + post;
    };
  }

  /* ---------- Tracking ---------- */
  function track(event, data) {
    window.dataLayer = window.dataLayer || [];
    var payload = { event: event };
    for (var k in data) payload[k] = data[k];
    if (payload.ecommerce) window.dataLayer.push({ ecommerce: null });
    window.dataLayer.push(payload);
  }

  function currency() {
    return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'DKK';
  }

  function item(el, qty) {
    var price = Number(el.dataset.price || 0) / 100;
    return {
      item_id: el.dataset.itemId,
      item_name: el.dataset.itemName,
      price: price,
      quantity: qty || 1
    };
  }

  /* =====================================================================
     1. Smagsvælger
     ===================================================================== */

  function initHero(hero) {
    var picks = hero.querySelectorAll('[data-pick]');

    function activate(key, source) {
      var pick = hero.querySelector('[data-pick="' + CSS.escape(key) + '"]');
      if (!pick) return false;
      hero.dataset.active = key;
      picks.forEach(function (p) { p.setAttribute('aria-pressed', p === pick ? 'true' : 'false'); });

      // Antallet nulstilles ved skift
      var box = hero.querySelector('.pp-hero__buybox[data-flavour="' + CSS.escape(key) + '"] [data-pp-atc]');
      if (box) setQty(box, 1);

      // Lazy-billedet til den nye smag hentes nu, ikke først når det scrolles i syne
      var img = hero.querySelector('.pp-hero__img[data-flavour="' + CSS.escape(key) + '"] img[loading="lazy"]');
      if (img) img.loading = 'eager';

      var it = item(pick, 1);
      if (source === 'click') {
        track('select_item', { ecommerce: { item_list_name: hero.dataset.listName || 'Persian Perry landingpage', items: [it] } });
      }
      track('view_item', { ecommerce: { currency: currency(), value: it.price, items: [it] } });
      return true;
    }

    picks.forEach(function (p) {
      p.addEventListener('click', function () {
        if (p.dataset.pick !== hero.dataset.active) activate(p.dataset.pick, 'click');
      });
    });

    // Mobil: fortæl CSS'en hvor scenen ligger, så ordet kan spredes over og under produktet
    var stage = hero.querySelector('.pp-hero__stage');
    function placeWords() {
      if (!stage || desktop.matches) {
        hero.style.removeProperty('--pp-stage-top');
        hero.style.removeProperty('--pp-stage-h');
        return;
      }
      var top = stage.getBoundingClientRect().top - hero.getBoundingClientRect().top;
      hero.style.setProperty('--pp-stage-top', Math.round(top) + 'px');
      hero.style.setProperty('--pp-stage-h', Math.round(stage.offsetHeight) + 'px');
    }
    placeWords();
    if (window.ResizeObserver) new ResizeObserver(placeWords).observe(hero);
    else window.addEventListener('resize', placeWords);

    var fromUrl = new URLSearchParams(window.location.search).get('smag');
    if (!(fromUrl && activate(fromUrl.toLowerCase(), 'url'))) {
      var start = hero.querySelector('[data-pick="' + CSS.escape(hero.dataset.active) + '"]');
      if (start) {
        var it = item(start, 1);
        track('view_item', { ecommerce: { currency: currency(), value: it.price, items: [it] } });
      }
    }
  }

  /* =====================================================================
     2. Antal og kurv
     ===================================================================== */

  function qtyInput(form) { return form.querySelector('[data-pp-qty]'); }

  function maxQty(form) {
    var input = qtyInput(form);
    return Math.max(1, Number(input && input.max) || 99);
  }

  function setQty(form, n) {
    var input = qtyInput(form);
    if (!input) return;
    // En kasse har altid sit faste antal, også efter "Lagt i kurven"
    if (form.dataset.packQty) n = Number(form.dataset.packQty);
    else n = Math.min(maxQty(form), Math.max(1, Math.round(Number(n) || 1)));
    input.value = n;
    renderCta(form);
  }

  function renderCta(form) {
    var text = form.querySelector('[data-pp-cta-text]');
    if (!text || form.dataset.flash === '1') return;
    var root = form.closest('[data-money-sample]');
    var fmt = moneyFormatter(root && root.dataset.moneySample);
    var qty = Number(qtyInput(form).value) || 1;
    var label = qty > 1 && !form.dataset.packQty ? form.dataset.labelPlural : form.dataset.label;
    var price = form.dataset.showPrice === 'false' ? '' : ' · ' + fmt(Number(form.dataset.price) * qty);
    text.textContent = label + price;
  }

  function showError(form, message) {
    var el = form.querySelector('[data-pp-error]');
    if (!el) return;
    el.textContent = message || '';
    el.hidden = !message;
  }

  function initAtc(form) {
    form.querySelectorAll('[data-pp-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        setQty(form, Number(qtyInput(form).value) + Number(btn.dataset.ppStep));
      });
    });
    var input = qtyInput(form);
    if (input && input.type === 'number') {
      input.addEventListener('change', function () { setQty(form, input.value); });
    }
    form.addEventListener('submit', function (e) { onAdd(e, form); });
    renderCta(form);
  }

  async function onAdd(e, form) {
    if (window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.cartType === 'page') return;
    e.preventDefault();

    var btn = form.querySelector('[data-pp-cta]');
    if (btn.getAttribute('aria-busy') === 'true') return;
    btn.setAttribute('aria-busy', 'true');
    showError(form, '');

    var qty = Number(qtyInput(form).value) || 1;
    var variantId = form.querySelector('[name="id"]').value;

    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));
    var sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } }));

    var fd = new FormData();
    fd.append('id', variantId);
    fd.append('quantity', String(qty));
    fd.append('sections', sections.join(','));
    fd.append('sections_url', Shopify.routes.root + 'variants/' + variantId);

    try {
      var res = await fetch(Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: fd,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      });
      var json = await res.json();
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

      if (!res.ok) {
        // Fx 422, hvis der er færre på lager end ønsket. Shopifys egen besked vises.
        btn.removeAttribute('aria-busy');
        showError(form, json.description || json.message || '');
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        return;
      }

      var it = item(form, qty);
      track('add_to_cart', {
        placement: form.dataset.placement,
        ecommerce: { currency: currency(), value: it.price * qty, items: [it] }
      });

      var text = form.querySelector('[data-pp-cta-text]');
      form.dataset.flash = '1';
      text.textContent = form.dataset.addedLabel;

      var cart = await (await fetch(Shopify.routes.root + 'cart.js')).json();
      cart.sections = json.sections;

      // Drawer åbnes, lidt efter at knappen har sagt "Lagt i kurven"
      setTimeout(function () {
        document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
          bubbles: true,
          detail: { baseEvent: 'variant:add', cart: cart }
        }));
      }, 450);

      setTimeout(function () {
        form.dataset.flash = '';
        btn.removeAttribute('aria-busy');
        setQty(form, 1);
      }, 1600);
    } catch (err) {
      console.error('[pp] kurv-fejl', err);
      document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));
      btn.removeAttribute('aria-busy');
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      // Uden JSON-svar sendes formularen almindeligt, så kunden ikke står fast
      form.submit();
    }
  }

  /* =====================================================================
     3. TikTok-facade
     ===================================================================== */

  function initTikTok(btn) {
    btn.addEventListener('click', function () {
      var id = btn.dataset.videoId;
      var card = btn.closest('[data-pp-tt]');
      if (!id || !card) return;
      var frame = document.createElement('iframe');
      frame.src = 'https://www.tiktok.com/embed/v2/' + encodeURIComponent(id) + '?autoplay=1';
      frame.title = btn.dataset.title || 'TikTok';
      frame.allow = 'autoplay; encrypted-media; fullscreen; picture-in-picture';
      frame.allowFullscreen = true;
      card.classList.add('is-playing');
      card.querySelectorAll('.pp-tt__poster, [data-pp-tt-play]').forEach(function (n) { n.remove(); });
      card.appendChild(frame);
      track('video_start', { video_provider: 'tiktok', video_id: id, video_title: btn.dataset.title || '' });
    });
  }

  function initTikTokLink(a) {
    a.addEventListener('click', function () {
      track('select_content', { content_type: 'tiktok_video', content_id: a.dataset.videoId || a.href });
    });
  }

  /* =====================================================================
     4. Klaviyo
     ===================================================================== */

  function klaviyoForm(form, buildBody, endpoint, onSuccess) {
    var input = form.querySelector('input[type="email"]');
    var submit = form.querySelector('[type="submit"]');
    var submitLabel = submit.textContent;
    var busy = false;

    function setBusy(state) {
      busy = state;
      submit.disabled = state;
      submit.textContent = state ? (form.dataset.busyLabel || submitLabel) : submitLabel;
    }

    input.addEventListener('input', function () {
      input.removeAttribute('aria-invalid');
      showError(form, '');
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (busy) return;
      var email = input.value.trim();
      showError(form, '');

      if (!EMAIL_RE.test(email)) {
        input.setAttribute('aria-invalid', 'true');
        showError(form, form.dataset.errorEmail);
        input.focus();
        return;
      }

      setBusy(true);
      fetch(endpoint + '?company_id=' + encodeURIComponent(form.dataset.companyId), {
        method: 'POST',
        headers: { 'content-type': 'application/json', revision: form.dataset.revision || '2024-10-15' },
        body: JSON.stringify(buildBody(email))
      })
        .then(function (res) {
          // Klaviyo svarer 202 Accepted uden indhold
          if (res.ok || res.status === 202) {
            form.hidden = true;
            var ok = form.parentElement.querySelector('[data-pp-success]');
            if (ok) ok.hidden = false;
            if (onSuccess) onSuccess();
            return;
          }
          return res.text().then(function (t) {
            console.error('[pp] Klaviyo svarede ' + res.status + ': ' + t);
            setBusy(false);
            showError(form, form.dataset.errorGeneric);
          });
        })
        .catch(function (err) {
          console.error('[pp] netværksfejl', err);
          setBusy(false);
          showError(form, form.dataset.errorGeneric);
        });
    });
  }

  function initNewsletter(form) {
    klaviyoForm(form, function (email) {
      var props = {};
      if (form.dataset.signupSource) props.signup_source = form.dataset.signupSource;
      if (form.dataset.interest) props.interest = form.dataset.interest;
      return {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: form.dataset.source || undefined,
            profile: { data: { type: 'profile', attributes: { email: email, properties: props } } }
          },
          relationships: { list: { data: { type: 'list', id: form.dataset.listId } } }
        }
      };
    }, 'https://a.klaviyo.com/client/subscriptions/', function () {
      track('sign_up', { method: 'klaviyo', signup_source: form.dataset.signupSource || '' });
    });
  }

  function initNotify(form) {
    // Med en liste i editoren kommer kunden på listen, så I selv bestemmer, hvornår der sendes
    if (form.dataset.listId) {
      klaviyoForm(form, function (email) {
        return {
          data: {
            type: 'subscription',
            attributes: {
              custom_source: form.dataset.source || undefined,
              profile: { data: { type: 'profile', attributes: { email: email, properties: { notify_product: form.dataset.product } } } }
            },
            relationships: { list: { data: { type: 'list', id: form.dataset.listId } } }
          }
        };
      }, 'https://a.klaviyo.com/client/subscriptions/', function () {
        track('back_in_stock_signup', { variant_id: form.dataset.variantId });
      });
      return;
    }
    klaviyoForm(form, function (email) {
      return {
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + form.dataset.variantId } }
          }
        }
      };
    }, 'https://a.klaviyo.com/client/back-in-stock-subscriptions/', function () {
      track('back_in_stock_signup', { variant_id: form.dataset.variantId });
    });
  }

  /* =====================================================================
     Teaser: blød scroll til Scary Perry
     ===================================================================== */

  function initScroll(a) {
    a.addEventListener('click', function (e) {
      var target = document.getElementById(a.hash.slice(1));
      if (!target) return;
      e.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', a.hash);
    });
  }

  /* ---------- Ingredienser og næringsindhold (snippets/pp-facts.liquid) ----------
     På desktop er kolonnerne i hero og Scary centreret lodret, så købeknappen ville hoppe op,
     når boksen foldes ud. Lige før den åbner, låses hver kolonne, hvor den står, og
     baggrundsordet låses i sin højde. Så er det kun indholdet under boksen, der rykker ned. */


  function initFacts(details) {
    var grid = details.closest('.pp-hero__inner, .pp-scary__grid');
    var summary = details.querySelector('summary');
    if (!grid || !summary) return;
    var words = grid.parentElement.querySelector('.pp-hero__words');

    summary.addEventListener('click', function () {
      if (details.open || !desktop.matches || grid.__ppFrozen) return;
      var pad = parseFloat(getComputedStyle(grid).paddingTop) || 0;
      var kids = Array.prototype.slice.call(grid.children);
      var tops = kids.map(function (c) { return c.offsetTop - pad; });
      if (words) { words.style.height = words.offsetHeight + 'px'; words.style.bottom = 'auto'; }
      grid.style.alignContent = 'start';
      kids.forEach(function (c, i) { c.style.alignSelf = 'start'; c.style.marginTop = Math.max(0, tops[i]) + 'px'; });
      grid.__ppFrozen = details;
    });

    details.addEventListener('toggle', function () {
      if (details.open || grid.__ppFrozen !== details) return;
      grid.__ppFrozen = null;
      grid.style.alignContent = '';
      Array.prototype.forEach.call(grid.children, function (c) { c.style.alignSelf = ''; c.style.marginTop = ''; });
      if (words) { words.style.height = ''; words.style.bottom = ''; }
    });
  }

  /* ---------- Guide-panel ----------
     Guidens sektioner står i templaten efter pp-guide og flyttes her ind i panelet. I
     tema-editoren bliver de stående, så de kan redigeres som normalt. */
  function initGuide(root) {
    var panel = root.querySelector('dialog');
    var body = root.querySelector('[data-pp-guide-body]');
    var open = root.querySelector('[data-pp-guide-open]');
    var host = root.closest('.shopify-section');
    if (!panel || !body || !open || !host || !panel.showModal) return;

    if (window.Shopify && Shopify.designMode) {
      open.hidden = true;
      return;
    }

    // Kun templatens egne sektioner. Footerens sektioner kan stå i samme forælder, men har
    // et andet præfiks i id'et (sections--… i stedet for template--…).
    var prefix = host.id.split('__')[0] + '__';
    var next = host.nextElementSibling;
    while (next) {
      var move = next;
      next = next.nextElementSibling;
      if (move.classList.contains('shopify-section') && move.id.indexOf(prefix) === 0) body.appendChild(move);
    }

    open.addEventListener('click', function () {
      panel.showModal();
      panel.scrollTop = 0;
      track('pp_guide_open', {});
    });
    root.querySelector('[data-pp-guide-close]').addEventListener('click', function () { panel.close(); });
    panel.addEventListener('click', function (e) { if (e.target === panel) panel.close(); });
    panel.addEventListener('close', function () { open.focus(); });
  }

  /* ---------- Tilbud: nedtælling til slutdatoen ---------- */

  // Slutdatoen (ÅÅÅÅ-MM-DD) gælder til 23.59.59 dansk tid, uanset hvor den besøgende er.
  function copenhagenEnd(ymd) {
    var p = String(ymd).split('-').map(Number);
    if (p.length !== 3 || p.some(isNaN)) return null;
    var guess = new Date(Date.UTC(p[0], p[1] - 1, p[2], 23, 59, 59));
    var offset = 1;
    try {
      var name = new Intl.DateTimeFormat('en-US', { timeZone: 'Europe/Copenhagen', timeZoneName: 'shortOffset' })
        .formatToParts(guess).find(function (x) { return x.type === 'timeZoneName'; }).value;
      var m = name.match(/GMT([+-]\d+)/);
      if (m) offset = Number(m[1]);
    } catch (e) { /* ældre browser: vintertid */ }
    return new Date(guess.getTime() - offset * 3600000);
  }

  function initDeal(deal) {
    var end = deal.dataset.end ? copenhagenEnd(deal.dataset.end) : null;
    if (!end) return;
    var clock = deal.querySelector('[data-pp-countdown]');
    var cells = {};
    if (clock) clock.querySelectorAll('[data-u]').forEach(function (b) { cells[b.dataset.u] = b; });
    var badges = deal.closest('[data-pp-hero]')
      ? deal.closest('[data-pp-hero]').querySelectorAll('.pp-pick__badge')
      : [];

    function put(u, n) {
      var el = cells[u];
      if (!el) return;
      var v = String(n).padStart(2, '0');
      if (el.textContent !== v) {
        el.textContent = v;
        // Lille vip på tallet, der skifter (slået fra ved reduceret bevægelse i CSS)
        el.classList.remove('is-tick');
        void el.offsetWidth;
        el.classList.add('is-tick');
      }
    }

    function tick() {
      var left = end.getTime() - Date.now();
      if (left <= 0) {
        // Tilbuddet er slut: alt om det forsvinder, også på en cachet side
        deal.hidden = true;
        badges.forEach(function (b) { b.hidden = true; });
        return false;
      }
      put('d', Math.floor(left / 86400000));
      put('h', Math.floor(left % 86400000 / 3600000));
      put('m', Math.floor(left % 3600000 / 60000));
      put('s', Math.floor(left % 60000 / 1000));
      return true;
    }

    if (tick()) {
      var timer = setInterval(function () { if (!tick()) clearInterval(timer); }, 1000);
    }
  }

  /* ---------- Find butik: kædelogo -> nærmeste butik i kæden ---------- */

  // Klikket beder om placeringen her (en brugerhandling) og gemmer den, hvor Find butik selv
  // leder efter den (sessionStorage, samme domæne). Siden åbner så med kæden valgt og den
  // nærmeste butik øverst. Siger kunden nej, åbner siden bare med kæden valgt.
  // Er logoet ensfarvet (>= 90 % af de synlige pixels i samme farve), tegnes det i heroens farve
  function detectMono(link) {
    var img = link.querySelector('.pp-stores__img');
    if (!img) return;
    function check() {
      try {
        var c = document.createElement('canvas');
        c.width = 64; c.height = 32;
        var ctx = c.getContext('2d');
        ctx.drawImage(img, 0, 0, 64, 32);
        var px = ctx.getImageData(0, 0, 64, 32).data, counts = {}, total = 0;
        for (var i = 0; i < px.length; i += 4) {
          if (px[i + 3] < 200) continue;
          var key = (px[i] >> 5) + '-' + (px[i + 1] >> 5) + '-' + (px[i + 2] >> 5);
          counts[key] = (counts[key] || 0) + 1;
          total++;
        }
        var top = 0;
        for (var k in counts) top = Math.max(top, counts[k]);
        if (total && top / total >= 0.9) link.classList.add('is-mono');
      } catch (e) { /* CORS eller gammel browser: logoet står i egne farver */ }
    }
    if (img.complete && img.naturalWidth) check();
    else img.addEventListener('load', check, { once: true });
  }

  function initStoreLink(link) {
    detectMono(link);
    link.addEventListener('click', function (e) {
      if (!navigator.geolocation || e.metaKey || e.ctrlKey) return;
      e.preventDefault();
      var href = link.href;
      var done = false;
      function go() { if (!done) { done = true; window.location.href = href; } }
      track('pp_store_click', { chain: link.dataset.chain || '' });
      navigator.geolocation.getCurrentPosition(function (pos) {
        try {
          sessionStorage.setItem('store-locator-location', JSON.stringify({
            lat: pos.coords.latitude, lng: pos.coords.longitude, timestamp: Date.now()
          }));
        } catch (err) { /* privat browsing */ }
        go();
      }, go, { timeout: 8000, maximumAge: 600000 });
      setTimeout(go, 10000);
    });
  }

  /* ---------- Opstart (og igen, når tema-editoren genindlæser en sektion) ---------- */

  function bind(root) {
    function each(sel, fn) {
      root.querySelectorAll(sel).forEach(function (el) {
        if (el.__pp) return;
        el.__pp = true;
        fn(el);
      });
    }
    each('[data-pp-hero]', initHero);
    each('[data-pp-atc]', initAtc);
    each('[data-pp-tt-play]', initTikTok);
    each('[data-pp-tt-link]', initTikTokLink);
    each('[data-pp-news]', initNewsletter);
    each('[data-pp-notify]', initNotify);
    each('[data-pp-scroll]', initScroll);
    each('.pp-facts', initFacts);
    each('[data-pp-guide]', initGuide);
    each('[data-pp-deal]', initDeal);
    each('[data-pp-store]', initStoreLink);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { bind(document); });
  } else {
    bind(document);
  }
  document.addEventListener('shopify:section:load', function (e) { bind(e.target); });
})();
